import { useQuery } from "@tanstack/react-query";
import appService from "../services/appService";



const GetDomainAndSubdomains=()=>{
   return useQuery({
    queryKey: ["getDomainAndSubdomains"],
    queryFn: () => appService.getDomainsAndSubDomains(),
  })
}

const GetLoggedInUserDetails=()=>{
return useQuery({
    queryKey: ["getUserDetails"],
    queryFn: () => appService.getLoggedInUserDetails(),
  });
}
 



export {GetDomainAndSubdomains,GetLoggedInUserDetails}